// Flow types automatically removed

import styles from './ProfileLoader.module.css';
import { Spinner } from 'dibs-elements/exports/Spinner.tsx';
export function Loader() {
    return (
        <div className={styles.wrapper}>
            <Spinner dark />
        </div>
    );
}
